import { __decorate, __metadata } from "tslib";
import { v4 as uuidv4 } from "uuid";
import { Type } from "class-transformer";
import { AssignedAssetsModel } from "./assignedAsset";
let EmployeeAssetsGridViewModel = /** @class */ (() => {
    class EmployeeAssetsGridViewModel {
        constructor() {
            this.id = uuidv4();
            this.employeeId = "";
            this.teamName = "";
            this.workPlace = "";
            this.assets = [];
        }
    }
    __decorate([
        Type(() => AssignedAssetsModel),
        __metadata("design:type", Array)
    ], EmployeeAssetsGridViewModel.prototype, "assets", void 0);
    return EmployeeAssetsGridViewModel;
})();
export { EmployeeAssetsGridViewModel };
export default class EmployeeAssetsGridView extends EmployeeAssetsGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
